import { createDatadogError } from '../datadog/utils/createDatadogError';

export namespace ExperimentServiceDomain {
    export enum ActiveExperiment {
        PATHFINDERS_UNIVERSALFLOW_CALLSCHEDULER = 'PATHFINDERS_UNIVERSALFLOW_CALLSCHEDULER',
        ZHL_HOMELOANS_DASHBOARD_MFA_FF = 'ZHL_HOMELOANS_DASHBOARD_MFA_FF',
    }

    export enum FeatureFlagStatus {
        OFF = 'off',
        ON = 'on',
    }

    export const EXPERIMENTS_LOG_PREFIX = '[EXPERIMENTS]';
    export const UnknownExperimentError = createDatadogError('UnknownExperimentError', EXPERIMENTS_LOG_PREFIX);
}
